import styled from 'styled-components'
import Caption from 'components/Caption'

export const StyledCaption = styled(Caption)<{ hasError: boolean }>`
  color: ${({ hasError, theme }) => (hasError ? theme.colors.red : 'unset')};
`

export const Text = styled.p`
  color: ${({ theme }) => theme.colors.text.dark.base};
`
